// Jul-2026 (User-Wunsch) — Rabatt-Höchstsätze aus den Einstellungen
// (Boni-Katalog → Rabatt-Regeln) auf Positions-Rabatte anwenden.
export function clampDiscountPct(rules, category, qty, price, requestedPct) {
    let cap = Infinity;
    let ruleName = null;
    for (const r of rules || []) {
        const applies = !(r.categories || []).length || (category && r.categories.includes(category));
        if (!applies) continue;
        let capPct;
        if (r.max_type === "eur") {
            const line = Math.abs(Number(qty || 1) * Number(price || 0));
            capPct = line > 0 ? (Number(r.max_value) / line) * 100 : Infinity;
        } else {
            capPct = Number(r.max_value);
        }
        if (capPct < cap) { cap = capPct; ruleName = r.name; }
    }
    if (Number(requestedPct) > cap) {
        return { pct: Math.max(0, Math.round(cap * 100) / 100), ruleName };
    }
    return null;
}
